import React from 'react';

// Components
import IconCloseEye from '../Icons/IconCloseEye/IconCloseEye';
import IconOpenEye from '../Icons/IconOpenEye/IconOpenEye';
import { CHECKBOX_BLOCK_CLASS, CHECKBOX_INPUT_CLASS, CHECKBOX_LABEL_CLASS, CHECKBOX_WRAPPER_CLASS, DEFAULT_BLOCK_CLASS, DEFAULT_INPUT_CLASS, DEFAULT_LABEL_CLASS, DEFAULT_WRAPPER_CLASS } from './constants';
import { InputControlProps } from './types';

const InputControl: React.FC<InputControlProps> = ({
  changePwdVisibility,
  customOnChange,
  elementByLeftSideLabel,
  iconRight,
  label,
  showPwd = false,
  errorText = '',
  onBlur,
  showError = false,
  customLabelClassName,
  customInputClassName,
  customBlockClassName,
  suggestion = '',
  ...inputProps
}) => {
  const pwdVisibility = inputProps.type === 'password';
  const isCheckbox = inputProps.type === 'checkbox';

  const inputPaddingClass = iconRight ? 'pr-8 2xl:pr-10' : 'pr-4 2xl:pr-6';

  const inputBlockClassName = customBlockClassName ?? (isCheckbox ? CHECKBOX_BLOCK_CLASS : DEFAULT_BLOCK_CLASS);
  const inputWrapperClassName = isCheckbox ? CHECKBOX_WRAPPER_CLASS : DEFAULT_WRAPPER_CLASS;
  const inputClassName = customInputClassName
    ? customInputClassName
    : isCheckbox
      ? CHECKBOX_INPUT_CLASS
      : `${DEFAULT_INPUT_CLASS} ${inputPaddingClass}`;
  const labelClassName = customLabelClassName
    ? customLabelClassName
    : isCheckbox ? CHECKBOX_LABEL_CLASS : DEFAULT_LABEL_CLASS;

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (customOnChange) {
      customOnChange(event);
    }

    if (inputProps.onChange) {
      inputProps.onChange(event);
    }
  };

  return (
    <div className={inputBlockClassName}>
      {label && (
        <label className={labelClassName}>
          {label}
          {inputProps.type !== 'checkbox' && elementByLeftSideLabel}
        </label>
      )}
      <div className={inputWrapperClassName}>
        <input
          {...inputProps}
          onChange={handleChange}
          className={`${inputClassName} ${showError
            ? 'focus:border-red dark:focus:border-red'
            : 'focus:border-primary dark:focus:border-primary'
          }`}
          type={showPwd && pwdVisibility ? 'text' : inputProps.type}
          onBlur={onBlur}
        />
        {iconRight && !pwdVisibility && (
          <span className="c-input-control__input-icon absolute right-4 top-4">
            {iconRight}
          </span>
        )}
        {pwdVisibility && (
          <>
            {showPwd ? (
              <IconOpenEye
                iconClassName="cursor-pointer absolute right-4 opacity-60 top-[21px] text-black dark:text-white"
                onClick={changePwdVisibility}
              />
            ) : (
              <IconCloseEye
                iconClassName="cursor-pointer absolute opacity-60 right-4 top-4 text-black dark:text-white"
                onClick={changePwdVisibility}
              />
            )}
          </>
        )}
      </div>
      <div className="flex min-h-6 items-center justify-start text-xs 2xl:text-base col-span-2">
        {showError && <p className="text-sm text-red">{errorText}</p>}
        {(!showError && suggestion) && <p className="text-sm text-success">{suggestion}</p>}
      </div>
    </div>
  );
};

export default InputControl;
